import * as Yup from "yup";

export const POLICY_VERSION = "2026";

export function initialValues() {
  return {
    email: "",
    password: "",
    repeatPassword: "",
    conditionsAccepted: false,
    policyVersion: POLICY_VERSION,
  };
}

export function validationSchema(t) {
  return Yup.object({
    email: Yup.string()
      .email(t("invalid_email"))
      .required(t("required_field")),
    password: Yup.string()
    .min(8, t("password_min_8_chars"))
      .matches(/[0-9]/, t("password_requires_number"))
      .matches(/[a-z]/, t("password_requires_lowercase"))
      .matches(/[A-Z]/, t("password_requires_uppercase"))
      .matches(/[^\w]/, t("password_requires_symbol"))
    .required(t("required_field")),
    repeatPassword: Yup.string()
      .required(t("required_field"))
      .oneOf([Yup.ref("password")], t("passwords_must_match")),
    conditionsAccepted: Yup.bool().isTrue(true),
  });
}
